var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"crly-a-contents-sort-item list-group-item crly-icon",class:_vm.item.class,attrs:{"itemKey":_vm.item.key}},[_c('label',[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('span',{staticClass:"handle",on:{"touchmove":function($event){$event.preventDefault();}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }